import React from "react";
import { BarChart, Bar, Tooltip, ResponsiveContainer, CartesianGrid, XAxis, YAxis } from "recharts";

export const BarChartByYear = (props) => {
  const CustomizedAxisTick = (props) => {
    const { x, y, stroke, payload } = props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} textAnchor="end" fill="#666">
          ${payload.value}
        </text>
      </g>
    );
  };
  return (
    <ResponsiveContainer height={props.height ? props.height : 450} width="100%">
      <BarChart data={props?.data} barSize={30}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis tick={<CustomizedAxisTick />} />
        <Tooltip cursor={{ fill: "transparent" }} />

        <Bar dataKey="totalnumberofearning" stackId="a" fill={props.color} />
      </BarChart>
    </ResponsiveContainer>
  );
};
